import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthSessionService } from '../../auth-session.service';
import { environment } from '../../../environments/environment';

type AuthenticationResponse = {
  token: string;
};

@Component({
  imports: [ReactiveFormsModule],
  selector: 'app-login',
  styleUrl: './login.scss',
  templateUrl: './login.html',
})
export class Login {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);
  private readonly authSession = inject(AuthSessionService);

  readonly loginForm = new FormGroup({
    username: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  });
  readonly token = signal<string | null>(null);
  readonly errorMessage = signal<string | null>(null);
  readonly isSubmitting = signal(false);

  submit(): void {
    if (this.loginForm.invalid || this.isSubmitting()) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const { username } = this.loginForm.getRawValue();
    this.isSubmitting.set(true);
    this.errorMessage.set(null);
    this.token.set(null);

    this.http.post<AuthenticationResponse>(environment.authUrl + "mtc-session-token", { username }, {
      headers: { programkey: environment.programkey },
    }).subscribe({
      next: ({ token }) => {
        this.token.set(token);


        this.http.get(environment.authUrl + "profile", {
          headers: { 'programkey': environment.programkey, 'mtc-session-token': token}
        }).subscribe((profile)=>{
          console.log(profile);
          this.authSession.persist(username, token, profile);
          this.isSubmitting.set(false);
          void this.router.navigateByUrl('/home');
        });


      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage.set(error.error?.message ?? 'Invalid Passcode. Please try again.');
        this.isSubmitting.set(false);
      },
    });
  }
}
